export default "__VITE_ASSET__BvOfKgiN__"